import React, { useState, createContext, useContext } from 'react';
interface HydrationContextType {
  dailyGoal: number;
  currentIntake: number;
  addIntake: (amount: number) => void;
  resetIntake: () => void;
  bottlesSaved: number;
  streakDays: number;
  userProfile: {
    name: string;
    weight: number;
    age: number;
    activityLevel: string;
  };
  updateProfile: (profile: any) => void;
}
const HydrationContext = createContext<HydrationContextType | undefined>(undefined);
export const HydrationProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [dailyGoal, setDailyGoal] = useState(2500); // ml
  const [currentIntake, setCurrentIntake] = useState(750);
  const [bottlesSaved, setBottlesSaved] = useState(12);
  const [streakDays, setStreakDays] = useState(5);
  const [userProfile, setUserProfile] = useState({
    name: 'Alex',
    weight: 70,
    age: 28,
    activityLevel: 'moderate'
  });
  const addIntake = (amount: number) => {
    setCurrentIntake(prev => Math.min(prev + amount, dailyGoal));
    setBottlesSaved(prev => prev + 1);
  };
  const resetIntake = () => {
    setCurrentIntake(0);
  };
  const updateProfile = (profile: any) => {
    setUserProfile({
      ...userProfile,
      ...profile
    });
    // Recalculate daily goal based on new profile
    if (profile.weight || profile.activityLevel) {
      const baseGoal = profile.weight ? profile.weight * 30 : dailyGoal;
      const activityMultiplier = profile.activityLevel === 'high' ? 1.2 : profile.activityLevel === 'moderate' ? 1.1 : 1;
      setDailyGoal(Math.round(baseGoal * activityMultiplier));
    }
  };
  return <HydrationContext.Provider value={{
    dailyGoal,
    currentIntake,
    addIntake,
    resetIntake,
    bottlesSaved,
    streakDays,
    userProfile,
    updateProfile
  }} data-id="element-1524">
      {children}
    </HydrationContext.Provider>;
};
export const useHydration = () => {
  const context = useContext(HydrationContext);
  if (context === undefined) {
    throw new Error('useHydration must be used within a HydrationProvider');
  }
  return context;
};